module.exports = __webpack_public_path__ + "messenger-35e78f24009e4f72c88f.svg";